// extracted by mini-css-extract-plugin
module.exports = {"ImageLoader":"ImageLoader_ImageLoader__3DrJ-","Image":"ImageLoader_Image__2Wqlk","Layout":"ImageLoader_Layout__7V_E1","Standar":"ImageLoader_Standar__kkE-a"};